import { render, staticRenderFns } from "./ItemTypeList.vue?vue&type=template&id=b86dbdd0&scoped=true"
import script from "./ItemTypeList.vue?vue&type=script&lang=ts"
export * from "./ItemTypeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86dbdd0",
  null
  
)

export default component.exports